var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar'),_c('Guideline'),_c('FooterPane')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }